import React from 'react';
import { Link } from 'react-router-dom';
import './CECertification.css';

const CECertification = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">Product Certification</div>
            <h1 className="page-title">CE Certification</h1>
            <div className="page-text-content">
              <p>
                Hello Valued Visitors,
              </p>
              <p>
                As NQC (Nova Quality Certification Agency), we continue to uphold our commitment to 
                providing you with the highest quality of service as a professional provider 
                specializing in certification and compliance. In this article, we aim to provide 
                detailed information about one of our services, CE Certification.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is CE?</h2>
            <div className="page-text-content">
              <p>
                The CE mark stands for "Conformité Européene," which is an abbreviation formed from 
                the initials of the French phrase. It signifies the free movement of products into 
                the European Union (EU) market. CE Certification represents a process of confirmation 
                that products comply with legal requirements in the EU.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Should You Get CE Certification?</h2>
            <div className="reasons-list">
              <div className="reason-item">
                <h3 className="reason-title">1. Access to the European Market</h3>
                <p className="reason-description">
                  CE Certification enables your products to enter the EU market freely. The CE mark is 
                  necessary for selling your products in EU countries.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">2. Product Safety</h3>
                <p className="reason-description">
                  CE Certification demonstrates that your products comply with safety and performance 
                  standards in the EU, ensuring the safety of users and emphasizing the quality of 
                  your product.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">3. Legal Compliance</h3>
                <p className="reason-description">
                  CE marking is mandatory for many products in the EU. CE Certification confirms that 
                  your products comply with EU laws and regulations.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">4. Competitive Advantage</h3>
                <p className="reason-description">
                  Products carrying the CE mark are preferred by consumers and businesses, providing 
                  a competitive edge.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">How to Obtain CE Certification?</h2>
            <div className="page-text-content">
              <p>
                The CE Certification process involves conformity assessment procedures that vary 
                depending on the product type. As NQC, we make this process easier for you with our 
                experienced professionals and comprehensive service approach. Our expert team guides you 
                through every step of the certification process, from initial assessment to final 
                certification.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Choose NQC (Nova Quality Certification Agency)?</h2>
            <div className="page-text-content">
              <p>
                As NQC, we provide high-quality certification services, including CE Certification. 
                Our experienced team has extensive knowledge in managing the certification process 
                efficiently and effectively. We are committed to helping your business succeed in 
                the European market.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Final Words</h2>
            <div className="page-text-content">
              <p>
                CE Certification is of great importance for businesses that want to enter the European 
                market. As NQC, we are proud to assist you in this process. If you have any questions 
                or need more information about our certification services, our expert team will be 
                happy to assist you.
              </p>
              <p>
                Best wishes!
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default CECertification;

